export const ancillaryTypes = {
  CabinBaggage: "CabinBaggage",
  Baggage: "Baggage",
};
